import { render, staticRenderFns } from "./certificateAuthentication.vue?vue&type=template&id=446607ca&scoped=true&"
import script from "./certificateAuthentication.vue?vue&type=script&lang=js&"
export * from "./certificateAuthentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446607ca",
  null
  
)

export default component.exports